module.exports = __webpack_public_path__ + "static/media/hr-smart.2a1b0e9f.svg";